export const POLICY_ACTION_TYPES = {
  SET_POLICY_DATA: 'SET_POLICY_DATA',
  SET_POLICY_SORT_BY: 'SET_POLICY_SORT_BY',
  SET_POLICY_FILTER_BY: 'SET_POLICY_FILTER_BY',
  SET_POLICY_ITEMS_PER_PAGE: 'SET_POLICY_ITEMS_PER_PAGE',
  SET_POLICY_SEARCH_QUERY: 'SET_POLICY_SEARCH_QUERY',
  SET_POLICY_CLAIMS_DATA: 'SET_POLICY_CLAIMS_DATA'
}